module.exports = __webpack_public_path__ + "img/MADANI-KESEJAHTERAAN_WHITE.5e7a10ea.png";